import type { FC } from 'react'

import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router'

import RootRouter from '@web/app/routes/root-router'
import { store } from '@web/app/store'
import { AppBootstrap } from '@web/app/ui/app-bootstrap'
import { AppThemeProvider } from '@web/app/ui/app-theme-provider'

const App: FC = () => (
  <Provider store={store}>
    <AppThemeProvider>
      <AppBootstrap>
        <RouterProvider router={RootRouter} />
      </AppBootstrap>
    </AppThemeProvider>
  </Provider>
)

export default App
